<template>
    <div class="index">

        <div class="active">

            <div class="swiper-container relative">

                <div class="swiper-wrapper">

                    <div
                        class="swiper-slide"
                        v-for="(item,index) in bannerList"
                        :key="'swiper-slide-'+index"
                    >

                        <v-image class="pointer swiper-slide-img" :src="item.path" @click="openPage(item)" ></v-image>

                    </div>

                </div>

                <!-- 分页器 -->
                <div class="swiper-pagination"></div>

                <!-- Add Arrows -->
                <div class="swiper-button-next"></div>

                <div class="swiper-button-prev"></div>

            </div>

            <div class="active-title cf">

                <img class="fl" src="../../assets/images/activity_icon_hot@2x.png" />

                <span class="fl">最新活动</span>

            </div>

            <!-- 活动列表 -->
            <div class="active-box cf">

                <layout-active-item
                    v-for="(item,index) in activeList"
                    :key="'active-item-'+index"
                    :data="item"
                />

            </div>

            <!-- 分页器 -->
            <div v-if="count > 10" class="pagination-box">

                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="count"
                    @current-change="changePage"
                >
                </el-pagination>

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image/index';
import LayoutActiveItem from '../../layout/layout-active-item/main';
export default {
    name: "active",
    mixins: [mixin],
    components: {
        LayoutActiveItem,
        vImage
    }
}
</script>

<style scoped src="./style.css"></style>
